function dropdown() {



  const mediaQuery = window.matchMedia('(max-width: 992px)');
  const menu = document.querySelector('.gh-head-menu');
  const nav = menu?.querySelector('.nav');

  if (!nav) return;

  const logo = document.querySelector('.gh-head-logo');
  const navHTML = nav.innerHTML;

  const makeDropdown = function () {
    if (mediaQuery.matches || document.body.classList.contains('is-dropdown-loaded')) {
      return;
    }

    const submenuItems = [];
    const offsetBuffer = 312;

    while ((nav.offsetWidth + offsetBuffer) > menu.offsetWidth) {
      const navItem = nav.lastElementChild;

      if (navItem) {
        submenuItems.unshift(navItem);
        navItem.remove();
      } else {
        return;
      }
    }

    if (!submenuItems.length) {
      document.body.classList.add('is-dropdown-loaded');
      return;
    }

    const dropdownToggle = document.createElement('button');

    dropdownToggle.setAttribute('class', 'nav-more-toggle gh-icon-btn');
    dropdownToggle.setAttribute('aria-label', 'More');
    dropdownToggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><polygon points="0 0 24 0 24 24 0 24"/><path fill="#000" fill-rule="nonzero" d="M4.5,10.5 C3.675,10.5 3,11.175 3,12 C3,12.825 3.675,13.5 4.5,13.5 C5.325,13.5 6,12.825 6,12 C6,11.175 5.325,10.5 4.5,10.5 Z M19.5,10.5 C18.675,10.5 18,11.175 18,12 C18,12.825 18.675,13.5 19.5,13.5 C20.325,13.5 21,12.825 21,12 C21,11.175 20.325,10.5 19.5,10.5 Z M12,10.5 C11.175,10.5 10.5,11.175 10.5,12 C10.5,12.825 11.175,13.5 12,13.5 C12.825,13.5 13.5,12.825 13.5,12 C13.5,11.175 12.825,10.5 12,10.5 Z"/></g></svg>';

    const dropdownMenuItems = document.createElement('ul');
    const dropdownMenuFragment = document.createDocumentFragment();

    submenuItems.forEach(function (child) {
      dropdownMenuFragment.appendChild(child);
    });

    dropdownMenuItems.appendChild(dropdownMenuFragment);

    const dropdownMenu = document.createElement('div');
    dropdownMenu.classList.add('gh-dropdown');
    dropdownMenu.appendChild(dropdownMenuItems);

    const dropdownFragment = document.createDocumentFragment();
    dropdownFragment.appendChild(dropdownToggle);
    dropdownFragment.appendChild(dropdownMenu);

    const dropdownContainer = document.createElement('li');
    dropdownContainer.classList.add('gh-dropdown-container');
    dropdownContainer.appendChild(dropdownFragment);

    nav.appendChild(dropdownContainer);

    document.body.classList.add('is-dropdown-loaded');

    window.addEventListener('click', function (e) {
      if (document.body.classList.contains('is-dropdown-open')) {
        document.body.classList.remove('is-dropdown-open');
      } else if (dropdownToggle.contains(e.target)) {
        document.body.classList.add('is-dropdown-open');
      }
    });
  }

  if (logo) {
    imagesLoaded(logo, function () {
      setTimeout(makeDropdown, 100);
    });
  } else {
    setTimeout(makeDropdown, 50);
  }

  window.addEventListener('resize', function () {
    setTimeout(function () {
      document.body.classList.remove('is-dropdown-loaded')
      nav.innerHTML = navHTML;
      makeDropdown();
    }, 10);
  });


  window.addEventListener('click', function (e) {
    const dropDownToggle = document.querySelectorAll(".gh-cm-button");
    dropDownToggle.forEach(elClass => {
      elClass.classList.remove('gh-cm-dropdown-open')
    })

    if (e.target.closest('.gh-cm-button')) {
      e.target.classList.add('gh-cm-dropdown-open');
    }
  })


}
